import _createForOfIteratorHelper from "/root/workspace/__flow_work/__flow_builds/4b0429b5-cad2-45c8-80ed-a3346422ad2c/workspace/life-h5_pcAM/node_modules/_@babel_runtime@7.29.7@@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _regenerator from "/root/workspace/__flow_work/__flow_builds/4b0429b5-cad2-45c8-80ed-a3346422ad2c/workspace/life-h5_pcAM/node_modules/_@babel_runtime@7.29.7@@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/4b0429b5-cad2-45c8-80ed-a3346422ad2c/workspace/life-h5_pcAM/node_modules/_@babel_runtime@7.29.7@@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.all-settled.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Fun from "./index";
var phone_bill_recharge_type = true; //话费充值 提示弹窗
function unfinishedTaskFn(_x) {
  return _unfinishedTaskFn.apply(this, arguments);
}
function _unfinishedTaskFn() {
  _unfinishedTaskFn = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(data) {
    var _isMissionURL, promises, results, validResults, activeResults, i, result, _sURL;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _isMissionURL = window.location.href.indexOf("/usr/missionCenter?") > -1; //是否位于任务中心页
          window._activePageURL = (!_isMissionURL ? window.location.href : sessionStorage.getItem("beforeBindMobilePage")) || window.location.href;
          // promises，数组格式
          promises = [bindMobile(data), bindInviter(data), bindRealName(data), setAddress(data), uploadVideo(data), levelCompel(data), phoneBillRecharge(data), signContract(data), carBind(data)];
          _context.n = 1;
          return Promise.allSettled(promises);
        case 1:
          results = _context.v;
          //并行执行，并返回包含所有承诺结果的对象数组
          validResults = []; //当前符合条件的集合
          activeResults = []; //当前符合条件并且处于某个条件处理的页面内，不做处理
          for (i = 0; i < results.length; i++) {
            result = results[i];
            if (result.status === "rejected" && result.reason.type) {
              if (result.reason.type == "active") {
                activeResults.push(result);
              } else {
                validResults.push(result);
              }
            }
          }
          if (!(validResults.length === 0 && activeResults.length === 0)) {
            _context.n = 2;
            break;
          }
          if (window.location.href.indexOf("/usr/missionCenter?") > 0) {
            window.location.href = window._activePageURL;
          }
          return _context.a(2);
        case 2:
          if (!(_isMissionURL || activeResults.length > 0)) {
            _context.n = 3;
            break;
          }
          return _context.a(2, validResults);
        case 3:
          if (!(validResults.length >= 2)) {
            _context.n = 4;
            break;
          }
          if (!_isMissionURL) {
            if (activeResults.length === 0) {
              // alert(window.location.href)
              _sURL = sessionStorage.getItem("beforeBindMobilePage") || null;
              if (!_sURL) sessionStorage.setItem("beforeBindMobilePage", window.location.href); //记录绑定手机跳转前页面路径
            }
            window.__lendApp__.$router.push(Fun.getUrl("missionCenter")); //如果有两个或两个以上promist符合条件，则执行跳转到 任务中心列表页：
          }
          return _context.a(2, validResults);
        case 4:
          validResults.forEach(function (result) {
            redirectToPage(result.reason.type);
          });
        case 5:
          return _context.a(2);
      }
    }, _callee);
  }));
  return _unfinishedTaskFn.apply(this, arguments);
}
function redirectToPage(type) {
  var _isMissionURL = window.location.href.indexOf("/usr/missionCenter?") > -1; //是否位于任务中心页
  var _activePageURL = (!_isMissionURL ? window.location.href : sessionStorage.getItem("beforeBindMobilePage")) || window.location.href;
  var callbackUrl = "";
  var validate_page = JSON.parse(sessionStorage.getItem('validate_page')) || {};
  var name,
    params = {},
    query = {};
  switch (type) {
    case "bindMobile":
      if (_activePageURL.indexOf("/signPage/") > -1) {
        query.from = "signPage";
      }
      name = "editmobile";
      break;
    case "bindInviter":
      name = "Inviter";
      break;
    case "bindRealName":
      name = "personBank";
      query.from = "bindRealName";
      callbackUrl = _activePageURL.includes("/personBank") ? "".concat(Fun.getSiteRoot(), "/addons/yun_shop/?menu#/home?i=").concat(Fun.getKeyByI(), "&mid=").concat(Fun.getKeyByMid()) : _activePageURL;
      window.__lendApp__.$store.commit("setCallback", callbackUrl); // 设置回调 URL。
      break;
    case "setAddress":
      window.__lendApp__.$dialog.confirm({
        message: "\u8BF7\u8BBE\u7F6E\u9ED8\u8BA4\u5730\u5740",
        confirmButtonText: "去设置",
        showCancelButton: false
      }).then(function () {
        return window.__lendApp__.$router.push(Fun.getUrl("address"));
      });
      break;
    case "uploadVideo":
      name = "releaseVideo";
      query.from = "validate";
      break;
    case "levelCompel":
      name = "levelCompel";
      break;
    case "phoneBillRecharge":
      window.__lendApp__.$dialog.confirm({
        message: "".concat(validate_page.phone_bill_recharge_member.tips, "?"),
        confirmButtonText: '确定'
      }).then(function () {
        phone_bill_recharge_type = false;
        if (validate_page.phone_bill_recharge_member.type == 'copy') {
          // 绑卡，充值
          var rechargeUrl = Fun.getSiteRoot() + "/addons/yun_shop/?menu#/recharge_phone_bill/recharge_phone_bill/" + encodeURIComponent(validate_page.phone_bill_recharge_member.url) + "?i=" + Fun.getKeyByI();
          return window.location.href = rechargeUrl;
        } else {
          return window.location.href = validate_page.phone_bill_recharge_member.url; // 开卡
        }
      }).catch(function () {
        phone_bill_recharge_type = false;
      });
      break;
    case "signContract":
      window.__lendApp__.$dialog.confirm({
        message: "\u60A8\u6709\u5408\u540C\u672A\u7B7E\u7F72\u5B8C\u6210\uFF0C\u8BF7\u524D\u5F80\u7B7E\u7F72\u5408\u540C",
        confirmButtonText: '确定'
      }).then(function () {
        var cid = validate_page.shop_contract.cid || 0;
        var signUrl = Fun.getSiteRoot() + "/addons/yun_shop/?menu#/contractList?status=3&i=" + Fun.getKeyByI();
        if (cid) signUrl = signUrl + '&cid=' + cid;
        return window.location.href = signUrl;
      }).catch(function () {
        window.__lendApp__.$router.replace(Fun.getUrl("home"));
      });
      break;
    case "carBind":
      name = "carBind";
      break;
  }
  if (name) window.__lendApp__.$router.replace(Fun.getUrl(name, params, query));
}

// 判断当前页面是否需要进入邀请页，以及判断用户是否已经填写过邀请人和绑定手机
// 如果未填写或未绑定，则会跳转到邀请页。
function bindInviter(data) {
  if (data.invite_page !== 1) {
    return Promise.resolve(); //没有开启，resolve
  }
  if (data.is_login !== 1) {
    return Promise.resolve(); // 判断用户是否已登录
  }
  var ignoredPages = ["input_visit", "member/editmobile", "inviterAndPhone"]; // 忽略某些页面，不需要进入邀请页或者已在邀请相关页面内
  var requiresInvitation = !ignoredPages.some(function (page) {
    return window.location.href.includes(page);
  });
  if (window.location.href.indexOf("/inviter?") > -1 || !requiresInvitation) {
    return Promise.reject({
      type: "active",
      name: "填写邀请码"
    });
  }
  // 判断用户是否已有邀请码
  if (data.is_invite !== 1 && !window.__lendApp__.$store.state.is_Inviter || data.invite_mobile !== 1) {
    return Promise.reject({
      type: "bindInviter",
      name: "填写邀请码",
      icon: "icon-fontclass-yaoqingma",
      color: "#FF3835"
    }); // 需要跳转到邀请页面
  }
  return Promise.resolve();
}

// 绑定手机
function bindMobile(_x2) {
  return _bindMobile.apply(this, arguments);
} // 实名认证
function _bindMobile() {
  _bindMobile = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(data) {
    var is_bind_mobile, bind_mobile_page, bindMobilePageFn, _iterator, _step, item, _t, _t2;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          is_bind_mobile = data.is_bind_mobile, bind_mobile_page = data.bind_mobile_page;
          if (!(data.is_login !== 1)) {
            _context2.n = 1;
            break;
          }
          return _context2.a(2, Promise.resolve());
        case 1:
          if (!(is_bind_mobile === 0)) {
            _context2.n = 2;
            break;
          }
          return _context2.a(2, Promise.resolve());
        case 2:
          if (!(window.location.href.indexOf("member/editmobile") > -1)) {
            _context2.n = 3;
            break;
          }
          return _context2.a(2, Promise.reject({
            type: "active",
            name: "绑定手机"
          }));
        case 3:
          if (!(window.location.href.indexOf("/signPage/") > -1)) {
            _context2.n = 4;
            break;
          }
          return _context2.a(2, Promise.reject({
            type: "bindMobile",
            name: "绑定手机",
            icon: "icon-verification_phone",
            color: "#377BFE"
          }));
        case 4:
          bindMobilePageFn = function bindMobilePageFn(item, url) {
            // 判断是否符合场景页面
            if (window._activePageURL.indexOf(url) > -1) {
              return Promise.reject({
                type: "bindMobile",
                name: "绑定手机",
                icon: "icon-verification_phone",
                color: "#377BFE"
              });
            }
          };
          if (!(is_bind_mobile == 1)) {
            _context2.n = 5;
            break;
          }
          if (window.location.href.indexOf("/member/scaneditmobile") >= 0) {
            window.localStorage.setItem("is_force_mobile", 999);
          }
          return _context2.a(2, Promise.reject({
            type: "bindMobile",
            name: "绑定手机",
            icon: "icon-verification_phone",
            color: "#377BFE"
          }));
        case 5:
          if (!(is_bind_mobile == 2)) {
            _context2.n = 20;
            break;
          }
          _iterator = _createForOfIteratorHelper(bind_mobile_page);
          _context2.p = 6;
          _iterator.s();
        case 7:
          if ((_step = _iterator.n()).done) {
            _context2.n = 16;
            break;
          }
          item = _step.value;
          _t = item;
          _context2.n = _t === "member_center" ? 8 : _t === "goods_detail" ? 10 : _t === "promotion_center" ? 13 : 15;
          break;
        case 8:
          _context2.n = 9;
          return bindMobilePageFn(item, "/member?");
        case 9:
          return _context2.a(3, 15);
        case 10:
          _context2.n = 11;
          return bindMobilePageFn(item, "/goods/");
        case 11:
          _context2.n = 12;
          return bindMobilePageFn(item, "/groups/");
        case 12:
          return _context2.a(3, 15);
        case 13:
          _context2.n = 14;
          return bindMobilePageFn(item, "/member/extension?");
        case 14:
          return _context2.a(3, 15);
        case 15:
          _context2.n = 7;
          break;
        case 16:
          _context2.n = 18;
          break;
        case 17:
          _context2.p = 17;
          _t2 = _context2.v;
          _iterator.e(_t2);
        case 18:
          _context2.p = 18;
          _iterator.f();
          return _context2.f(18);
        case 19:
          return _context2.a(2, Promise.resolve());
        case 20:
          return _context2.a(2);
      }
    }, _callee2, null, [[6, 17, 18, 19]]);
  }));
  return _bindMobile.apply(this, arguments);
}
function bindRealName(data) {
  var _data$real_name_auth_;
  if (data.is_login !== 1) {
    return Promise.resolve(); // 判断用户是否已登录
  }
  // 定义排除的 URL。
  var excludedUrls = ["/personBank", "/signCompany", "/member/orderpay/auth/"];
  // 检查当前 URL 是否被排除。
  var currentUrl = window.location.href;
  if (excludedUrls.some(function (url) {
    return currentUrl.includes(url);
  })) {
    return Promise.reject({
      type: "active",
      name: "实名认证"
    });
  }
  // 检查实名认证插件是否开启并且需要进行认证。
  var isOpen = data.real_name_auth_is_open === 1;
  var needsAuth = data.is_auth !== 1 && ((_data$real_name_auth_ = data.real_name_auth_scene) === null || _data$real_name_auth_ === void 0 ? void 0 : _data$real_name_auth_.length) > 0;
  if (isOpen && needsAuth) {
    if (data.real_name_auth_scene.indexOf("1") > -1 && currentUrl.indexOf("/personBank") < 0) return Promise.reject({
      type: "bindRealName",
      name: "实名认证",
      icon: "icon-fontclass-wdeguanzhu",
      color: "#377BFE"
    });

    // 定义需要实名认证的场景 URL。
    var scenarioUrls = {
      2: ["/member/withdrawal?"],
      3: ["/videoAgreement?", "/releaseVideo?"],
      4: ["/microRelease?"],
      5: ["/member/extension?"],
      6: ["/member/supplier?"],
      7: ["/o2o/storeApply?"],
      8: ["/hotel/apply?"],
      9: ["/anchorApply?"]
    };
    // 检查当前 URL 是否匹配任何场景 URL。
    var needsRealName = data.real_name_auth_scene.some(function (scene) {
      var _scenarioUrls$scene;
      var urls = (_scenarioUrls$scene = scenarioUrls[scene]) !== null && _scenarioUrls$scene !== void 0 ? _scenarioUrls$scene : [];
      return urls.some(function (url) {
        return window._activePageURL.includes(url);
      });
    });
    if (needsRealName) {
      // 需要进行实名认证，跳转至实名认证页面。
      return Promise.reject({
        type: "bindRealName",
        name: "实名认证",
        icon: "icon-fontclass-wdeguanzhu",
        color: "#377BFE"
      });
    }
  }
  // 实名插件未开启或已实名认证过，直接下一步
  return Promise.resolve();
}

// 绑定地址
function setAddress(_ref) {
  var is_login = _ref.is_login,
    _ref$bind_address = _ref.bind_address,
    bind_address_type = _ref$bind_address.bind_address_type,
    bind_address_page = _ref$bind_address.bind_address_page,
    is_bind_address = _ref$bind_address.is_bind_address;
  if (is_login !== 1) {
    return Promise.resolve(); // 判断用户是否已登录
  }
  if (is_bind_address === 1) return Promise.resolve();
  var excludedUrls = ["/member/address", "/member/appendAddress", "/login"]; //当前链接符合该数组条件，拦截但不处理
  if (excludedUrls.some(function (url) {
    return window.location.href.includes(url);
  })) {
    return Promise.reject({
      type: "active",
      name: "绑定地址"
    });
  }
  var pageUrls = {
    member_center: "/member?",
    goods_detail: ["/goods/", "/groups/"],
    promotion_center: "/member/extension?"
  };
  var isBindPage = function isBindPage(pageUrl) {
    return Array.isArray(pageUrl) ? pageUrl.some(function (url) {
      return window._activePageURL.includes(url);
    }) : window._activePageURL.includes(pageUrl);
  };
  var isBindAddressPage = bind_address_type === 2 && bind_address_page.some(function (pageName) {
    return isBindPage(pageUrls[pageName]);
  });
  if (bind_address_type === 1) return Promise.reject({
    type: "setAddress",
    name: "绑定地址",
    icon: "icon-icon_location",
    color: "#29D99F"
  }); //全局绑定
  if (isBindAddressPage) return Promise.reject({
    type: "setAddress",
    name: "绑定地址",
    icon: "icon-icon_location",
    color: "#29D99F"
  }); //指定页面
  return Promise.resolve();
}

// 默认上传视频（需要上传过视频才可进入视频）
function uploadVideo(data) {
  if (data.is_login !== 1) {
    return Promise.resolve(); // 判断用户是否已登录
  }
  if (window.location.href.indexOf("/releaseVideo") > -1) {
    return Promise.reject({
      type: "active",
      name: "发布视频"
    });
  }
  if (data !== null && data !== void 0 && data.need_video && window.location.href.indexOf("/releaseVideo") <= -1) {
    return Promise.reject({
      type: "uploadVideo",
      name: "发布视频",
      icon: "icon-fontclass-ship",
      color: "#29D99F"
    });
  }
  return Promise.resolve();
}
function carBind(data) {
  if (data.is_login !== 1) {
    return Promise.resolve(); // 判断用户是否已登录
  }
  if (data !== null && data !== void 0 && data.force_bind_car && window.location.href.indexOf("/carBind") > -1) {
    return Promise.reject({
      type: "active",
      name: "绑定车牌"
    });
  }
  if (data !== null && data !== void 0 && data.force_bind_car && window.location.href.indexOf("/carBind") <= -1) {
    return Promise.reject({
      type: "carBind",
      name: "绑定车牌",
      icon: "icon-chepaihao",
      color: "#29D99F"
    });
  }
  return Promise.resolve();
}

// 新客下单
function levelCompel(data) {
  if (data.is_login !== 1) {
    return Promise.resolve(); // 判断用户是否已登录
  }
  var excludedUrls = ["/levelCompel", "/member/orderpay/", "/order/pay_back/", "/login"]; //当前链接符合该数组条件，拦截但不处理
  if (excludedUrls.some(function (url) {
    return window.location.href.includes(url);
  })) {
    return Promise.reject({
      type: "active",
      name: "新客下单"
    });
  }
  var isLevel = (data === null || data === void 0 ? void 0 : data.is_level_compel) && data.is_level_compel == 1;
  if (isLevel && window.location.href.indexOf("member/orderpay") <= -1 && window.location.href.indexOf("/order/pay_back") <= -1) {
    return Promise.reject({
      type: "levelCompel",
      name: "新客下单",
      icon: "icon-qt_button_groupbbuy",
      color: "#29D99F"
    });
  }
  return Promise.resolve();
}

// 话费充值 -- #19217
function phoneBillRecharge(data) {
  if (data.is_login !== 1) {
    return Promise.resolve(); // 判断用户是否已登录
  }
  if (window.location.href.indexOf("/recharge_phone_bill/recharge_phone_bill") > -1) {
    return Promise.reject({
      type: "active",
      name: "绑卡开卡"
    });
  }
  if (!phone_bill_recharge_type) {
    return Promise.resolve(); //已经弹过
  }
  // 满足phone_bill_recharge_member条件而且是在登陆后触发
  if (data && data.phone_bill_recharge_member && data.phone_bill_recharge_member.status == 1 && data.is_login == 1) {
    return Promise.reject({
      type: "phoneBillRecharge",
      name: "绑卡开卡",
      icon: "icon-qt_button_groupbbuy",
      color: "#29D99F"
    });
  }
  return Promise.resolve();
}
// #32329 如用户有待签署的合同时，无法进入会员中心和推广中心，弹出提示,点击“去签署”，则跳转到待签署的合同列表。
function signContract(data) {
  if (data.is_login !== 1) {
    return Promise.resolve(); // 判断用户是否已登录
  }
  var excludedUrls = ["/contractList", "/signBusiness", "/signPage"]; //当前链接符合该数组条件，拦截但不处理
  if (excludedUrls.some(function (url) {
    return window.location.href.includes(url);
  })) {
    return Promise.reject({
      type: "active",
      name: "合同签署"
    });
  }
  // 定义需要签署的场景
  var needSignUrls = ["/member", "/member/extension", '/usr/missionCenter'];
  // 检查当前 URL 是否匹配到指定场景 URL。
  var isNeedSignUrls = needSignUrls.some(function (url) {
    return window.location.href.includes(url);
  });
  if (isNeedSignUrls && data !== null && data !== void 0 && data.shop_contract && data !== null && data !== void 0 && data.shop_contract.member_center_status && data !== null && data !== void 0 && data.shop_contract.contract_id) {
    return Promise.reject({
      type: "signContract",
      name: "合同签署",
      icon: "icon-fontclass-gerenyinzhang",
      color: "#ee0a24"
    });
  }
  return Promise.resolve();
}
export { unfinishedTaskFn, redirectToPage };